import { PageHeader, PolicyholderContactsModule } from '@korint/folio';

export const DriverHomeView = () => {
  return (
    <div className="space-y-8">
      <PageHeader title="Accueil" />

      <PolicyholderContactsModule />
    </div>
  );
};
